exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".question-line .guide-list {\n  display: inline-block;\n  vertical-align: top;\n}\n.question-line .guide-list .guide-item {\n  border: 2px solid #e3ebf3;\n  border-radius: 2px;\n  text-align: center;\n  padding: 8px 30px;\n  background: #ffffff;\n  margin: 0 0 10px 0;\n}\n.question-line .guide-list .guide-item:last-child {\n  margin: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"importLoaders":1}!./src/entry_question_editor/question/exercise/pair/index.less
// module id = 1120
// module chunks = 60 61 62